import type { ReactNode } from 'react';
import { Box } from '@mui/material';
import { designTokens, PageSections } from '../../../design-system';

export function WorkflowTemplateLayout({ children, preview }: { children: ReactNode; preview: ReactNode }) {
  return <Box sx={{
    display: 'grid',
    gridTemplateColumns: { xs: 'minmax(0, 1fr)', lg: 'minmax(0, 1fr) 320px', xl: 'minmax(0, 1fr) 360px' },
    gap: `${designTokens.layout.pageSectionGap}px`,
    alignItems: 'start',
    minWidth: 0,
  }}>
    <PageSections>{children}</PageSections>
    {preview}
  </Box>;
}
